import script from "./CooperationApply.vue?vue&type=script&lang=ts&setup=true&name=CooperationApply"
export * from "./CooperationApply.vue?vue&type=script&lang=ts&setup=true&name=CooperationApply"

const __exports__ = script;

export default __exports__